export class CText extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          margin: 0;
        }

        .text {
          margin: 0;
        }

        /* Paragraphs */
        .p1 {
          font-size: 20px;
          line-height: 28px;
          font-weight: 400;
        }

        .p2 {
          font-size: 18px;
          line-height: 26px;
          font-weight: 400;
        }

        .p3 {
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
        }

        /* Semibold override for paragraphs */
        .semibold {
          font-weight: 600;
        }

        /* Headings */
        .h1 {
          font-size: 72px;
          line-height: 80px;
          font-weight: 700;
        }

        .h2 {
          font-size: 60px;
          line-height: 68px;
          font-weight: 700;
        }

        .h3 {
          font-size: 48px;
          line-height: 56px;
          font-weight: 700;
        }

        .h4 {
          font-size: 40px;
          line-height: 48px;
          font-weight: 700;
        }

        .h5 {
          font-size: 32px;
          line-height: 40px;
          font-weight: 700;
        }

        .h6 {
          font-size: 28px;
          line-height: 36px;
          font-weight: 700;
        }

        .h7 {
          font-size: 24px;
          line-height: 32px;
          font-weight: 700;
        }
        @media (max-width: 768px) {
            .h1 { font-size: 48px; line-height: 56px; }
            .h2 { font-size: 42px; line-height: 48px; }
            .h3 { font-size: 36px; line-height: 44px; }
            .h4 { font-size: 32px; line-height: 40px; }
            .h5 { font-size: 28px; line-height: 36px; }
            .h6 { font-size: 26px; line-height: 34px; }
            .h7 { font-size: 24px; line-height: 32px; }
        }

      </style>

      <span class="text"><slot></slot></span>
    `;
  }

  connectedCallback() {
    this.updateType();
  }

  static get observedAttributes() {
    return ["type", "semibold"];
  }

  attributeChangedCallback() {
    this.updateType();
  }

  updateType() {
    const type = this.getAttribute("type") || "p1";
    const semibold = this.hasAttribute("semibold");
    const textElement = this.shadowRoot.querySelector(".text");

    // Reset classes
    textElement.className = "text";

    textElement.classList.add(type);

    if (["p1", "p2", "p3"].includes(type) && semibold) {
      textElement.classList.add("semibold");
    }
  }
}

customElements.define("c-text", CText);